var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { BlueCheckbox } from '@hn-ui/checkboxes';
import { useToggle } from '@hn-front/utils';
import { styled } from 'styled-components';
import { GradeAccordion } from './GradeAccordion';
import { Chapters } from './Chapters';
import { assignChapter, deleteChapter, assignLesson, deleteLesson, } from './api';
import { ManageCurriculumEvents, useManageCurriculumAnalytics, } from './hooks/useManageCurriculumAnalytics';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-25pkpa" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-height: 480px;\n"], ["\n  min-height: 480px;\n"])));
var ShowLowerGrades = styled(BlueCheckbox).withConfig({ displayName: "ShowLowerGrades", componentId: "sc-4qplut" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 32px;\n  color: ", ";\n"], ["\n  margin-bottom: 32px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black50;
});
var Grades = function (_a) {
    var studentId = _a.studentId, curriculums = _a.curriculums, passedLessons = _a.passedLessons, currentGradeValue = _a.currentGradeValue, rest = __rest(_a, ["studentId", "curriculums", "passedLessons", "currentGradeValue"]);
    var _b = useState(passedLessons), assignedLessons = _b[0], setAssignedLessons = _b[1];
    var _c = useToggle(), isToggled = _c.isToggled, toggle = _c.toggle;
    var isShowFilter = currentGradeValue > 1;
    var filteredCurriculums = isToggled || !isShowFilter
        ? curriculums
        : curriculums.filter(function (_a) {
            var value = _a.value;
            return value >= currentGradeValue - 1;
        });
    var sendGaEvent = useManageCurriculumAnalytics();
    var handleOnChapterDelete = useCallback(function (chapterId) { return __awaiter(void 0, void 0, void 0, function () {
        var lessonIds;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, deleteChapter(chapterId, studentId)];
                case 1:
                    lessonIds = _a.sent();
                    setAssignedLessons(lessonIds);
                    sendGaEvent(ManageCurriculumEvents.manageCurriculumTopicDisable);
                    return [2 /*return*/];
            }
        });
    }); }, [studentId, sendGaEvent]);
    var handleOnChapterAssign = useCallback(function (chapterId) { return __awaiter(void 0, void 0, void 0, function () {
        var lessonIds;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, assignChapter(chapterId, studentId)];
                case 1:
                    lessonIds = _a.sent();
                    setAssignedLessons(lessonIds);
                    sendGaEvent(ManageCurriculumEvents.manageCurriculumTopicEnable);
                    return [2 /*return*/];
            }
        });
    }); }, [studentId, sendGaEvent]);
    var handleOnLessonDelete = useCallback(function (lessonId) { return __awaiter(void 0, void 0, void 0, function () {
        var lessonIds;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, deleteLesson(lessonId, studentId)];
                case 1:
                    lessonIds = _a.sent();
                    setAssignedLessons(lessonIds);
                    sendGaEvent(ManageCurriculumEvents.manageCurriculumTopicDisable);
                    return [2 /*return*/];
            }
        });
    }); }, [studentId, sendGaEvent]);
    var handleOnLessonAssign = useCallback(function (lessonId) { return __awaiter(void 0, void 0, void 0, function () {
        var lessonIds;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, assignLesson(lessonId, studentId)];
                case 1:
                    lessonIds = _a.sent();
                    setAssignedLessons(lessonIds);
                    sendGaEvent(ManageCurriculumEvents.manageCurriculumTopicEnable);
                    return [2 /*return*/];
            }
        });
    }); }, [studentId, sendGaEvent]);
    return (_jsxs(Container, __assign({}, rest, { children: [isShowFilter && (_jsx(ShowLowerGrades, { checked: isToggled, onChecked: toggle, text: 'Show lower grades' }, void 0)), filteredCurriculums.map(function (curriculum) { return (_jsx(GradeAccordion, __assign({ text: curriculum.name, isOpen: currentGradeValue === curriculum.value }, { children: _jsx(Chapters, { chapters: curriculum.chapters, assignedLessons: assignedLessons, onChapterAssign: handleOnChapterAssign, onChapterDelete: handleOnChapterDelete, onLessonAssign: handleOnLessonAssign, onLessonDelete: handleOnLessonDelete }, void 0) }), curriculum.id)); })] }), void 0));
};
export { Grades };
var templateObject_1, templateObject_2;
